import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { ReactElement } from 'react';
import { cohortNoticeText } from '../services/cohortLoading';

/**
 * Shown only when a queue hit its row cap.
 *
 * The chip counts beside it describe the loaded rows, which is exactly the
 * confusion BAR-2738 removed everywhere else — so where the cap makes it true
 * again, it has to be said out loud rather than left for a reader to infer.
 */
export interface CohortTruncationNoticeProps {
  loaded: number;
  /** From `useCohortTotal`; absent when the count failed. */
  total?: number;
}

export function CohortTruncationNotice({ loaded, total }: CohortTruncationNoticeProps): ReactElement {
  return (
    <Alert color="yellow" icon={<IconAlertTriangle size={16} />} py="xs">
      {cohortNoticeText(loaded, total)}
    </Alert>
  );
}
